import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { Box } from 'ui/bend'

const PLACEHOLDER_IMAGE =
  'https://alomoves.s3.amazonaws.com/manual_uploads/shared/search/placeholder-cards/rectangle-card.jpg'

const BannerRoot = styled(Box)(
  css({
    position: 'relative',
    width: '100%',
    minHeight: ['450px', null, '500px'],
    overflow: 'hidden',
    backgroundColor: '#191918'
  })
)

const BlurredBackdrop = styled(Box)(
  css({
    position: 'absolute',
    inset: '-24px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    filter: 'blur(28px) brightness(0.72)',
    transform: 'scale(1.08)'
  })
)

const Overlay = styled(Box)(
  css({
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.42) 100%)'
  })
)

const Foreground = styled(Box)(
  css({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: ['24px', null, '48px']
  })
)

const ForegroundImage = styled('img')(
  css({
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.28)'
  })
)

const EventDetailBanner = ({ coverUrl, title }) => {
  const [imageSrc, setImageSrc] = useState(coverUrl || PLACEHOLDER_IMAGE)

  return (
    <BannerRoot aria-label={title ? `${title} cover image` : 'Event cover image'}>
      <BlurredBackdrop
        style={{ backgroundImage: `url('${imageSrc}')` }}
        aria-hidden='true'
      />
      <Overlay aria-hidden='true' />
      <Foreground>
        <ForegroundImage
          src={imageSrc}
          alt={title || 'Event cover'}
          onError={() => setImageSrc(PLACEHOLDER_IMAGE)}
        />
      </Foreground>
    </BannerRoot>
  )
}

EventDetailBanner.propTypes = {
  coverUrl: PropTypes.string,
  title: PropTypes.string
}

export default EventDetailBanner
